import { camelCaseToSpaces } from 'utils/strings';
import {
  largeMarker,
  phoneMarker,
  porterbuddyMarker,
  smallMarker,
} from './mapMarkers';
import dayjs from 'dayjs';
import { MapPoints } from 'types/mapTypes';

export function infoWindowContent(info) {
  return `<div>
          ${Object.keys(info)
            .map(key => {
              return `
                  <div style="display: flex; justify-content: space-between">
                    <div>${camelCaseToSpaces(key)} &nbsp;</div>
                    <div>${info[key]}</div>
                  </div>`;
            })
            .join('')}
        </div>`;
}

export function courierInfoWidnowContent(info) {
  return `
    <div>
      <div>${info.courierName} &nbsp;</div>
      <div>${
        info?.locationUpdatedAt
          ? dayjs(info?.locationUpdatedAt).format('DD-MM. - HH:mm:ss')
          : null
      }</div>
    </div>
  `;
}

export function addMarker({
  position = { lat: 0.0, lng: 0.0 },
  icon = null,
  map = null,
  visible = true,
  addInfoWindow = false,
  info = {},
  infoWindow = null,
}): google.maps.Marker {
  const marker = new window.google.maps.Marker({
    position,
    map,
    icon,
    visible,
  });

  if (addInfoWindow && info && infoWindow) {
    marker.addListener('click', () => {
      infoWindow.setContent(infoWindowContent(info));
      infoWindow.open(map, marker);
    });
  }
  return marker;
}

export function googleMarkerIcon({
  type = 'small',
  backgroundColor = 'white',
  color = '',
  label = '',
  stroke = false,
}): google.maps.Icon {
  let markerIcon = smallMarker(backgroundColor, stroke, label, color);
  if (type === 'large') {
    markerIcon = largeMarker(backgroundColor, color || 'white', label);
  } else if (type === 'porterbuddy') {
    markerIcon = porterbuddyMarker;
  } else if (type === 'deliveryConfirmed') {
    markerIcon = phoneMarker;
  }
  return {
    url: markerIcon,
    anchor: new window.google.maps.Point(14, 42),
    scaledSize: new window.google.maps.Size(28, 42),
    labelOrigin: new window.google.maps.Point(14, 16),
  };
}

export function zoomMap(
  markers: google.maps.Marker[],
  mapInstance: google.maps.Map
) {
  const bounds = new google.maps.LatLngBounds();
  markers.forEach(marker => bounds.extend(marker.getPosition()));
  mapInstance.fitBounds(bounds);
  mapInstance.panToBounds(bounds);
}

export const pbMapStyle: google.maps.MapTypeStyle[] = [
  { featureType: MapPoints.ADMINISTRATIVE, stylers: [{ visibility: 'on' }] },
  { featureType: 'landscape', stylers: [{ saturation: -75 }] },
  {
    featureType: MapPoints.POI_ATTRACTION,
    stylers: [{ saturation: -95 }, { visibility: 'off' }],
  },
  {
    featureType: MapPoints.POI_ATTRACTION,
    elementType: MapPoints.LABELS_TEXT,
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: MapPoints.POI_BUSINESS,
    stylers: [{ saturation: -100 }, { visibility: 'off' }],
  },
  {
    featureType: MapPoints.POI_BUSINESS,
    elementType: 'geometry.fill',
    stylers: [{ saturation: -100 }, { visibility: 'on' }],
  },
  {
    featureType: MapPoints.POI_BUSINESS,
    elementType: MapPoints.LABELS_TEXT,
    stylers: [{ visibility: 'simplified' }],
  },
  { featureType: MapPoints.POI_GOVERNMENT, stylers: [{ visibility: 'off' }] },
  {
    featureType: MapPoints.POI_GOVERNMENT,
    elementType: MapPoints.LABELS_TEXT,
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: MapPoints.POI_MEDICAL,
    stylers: [{ saturation: -100 }, { visibility: 'simplified' }],
  },
  {
    featureType: MapPoints.POI_MEDICAL,
    elementType: MapPoints.LABELS_TEXT,
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: MapPoints.POI_PARK,
    stylers: [{ saturation: -70 }, { visibility: 'simplified' }],
  },
  {
    featureType: MapPoints.POI_PARK,
    elementType: MapPoints.LABELS_TEXT,
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: MapPoints.POI_PLACE_OF_WORSHIP,
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: MapPoints.POI_PLACE_OF_WORSHIP,
    elementType: MapPoints.LABELS_TEXT,
    stylers: [{ visibility: 'simplified' }],
  },
  { featureType: MapPoints.POI_PARK, stylers: [{ visibility: 'off' }] },
  {
    featureType: MapPoints.POI_SCHOOL,
    elementType: MapPoints.LABELS_TEXT,
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: MapPoints.POI_SPORTS_COMPLEX,
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: MapPoints.POI_SPORTS_COMPLEX,
    elementType: MapPoints.LABELS_TEXT,
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: MapPoints.ROAD,
    elementType: MapPoints.LABELS_ICON,
    stylers: [{ saturation: -85 }, { lightness: 40 }],
  },
  { featureType: MapPoints.ROAD_ARTERIAL, stylers: [{ saturation: -100 }] },
  { featureType: MapPoints.ROAD_HIGHWAY, stylers: [{ saturation: -65 }] },
  {
    featureType: MapPoints.ROAD_HIGHWAY_CONTROLLED,
    stylers: [{ saturation: -100 }, { visibility: 'on' }],
  },
  { featureType: MapPoints.ROAD_LOCAL, stylers: [{ saturation: -100 }] },
  {
    featureType: MapPoints.TRANSIT,
    stylers: [{ saturation: -80 }, { visibility: 'simplified' }],
  },
  { featureType: 'water', stylers: [{ saturation: -75 }] },
];
